import React, { Fragment } from "react";
import classes from "./Modal.module.css";
import Spinner from "../Spinner/Spinner";

const Modal = props => {
    return (
        <Fragment>
            {props.children} 
            {props.show? <div className={classes.Modal} ><Spinner /></div> : null}
        </Fragment>
    );
}

export default Modal;